<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li *ngIf="(loginPersonType != 'EMPLOYEE' && paramFieldForce == 'Staff') || loginPersonType == 'EMPLOYEE'">
            <a>Manage</a></li>
          <li *ngIf="loginUserBusinessCategory == 'Provider' && paramFieldForce == 'People'"><a>Farm Users</a></li>
          <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Business</a></li>
          <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>People</a></li>
          <li *ngIf="loginPersonType != 'EMPLOYEE' && paramFieldForce == 'Staff'"><a>Your Field Force</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home" *ngIf="loginUserBusinessCategory != 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
          <a routerLink="/home/dashboard" *ngIf="loginUserBusinessCategory == 'Provider'"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="screen_heading_div">
          <span>Persons</span>
        </div>
        <div *ngIf="!pgLoad">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div *ngIf="pgLoad">
          <div class="search_cum_icons_button_container">
            <div class="search-div" *ngIf="loginPersonType != 'Business Admin' && loginPersonType != 'Provider Manager'">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (keyup)="applySearch()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by person, role, business name etc..">
            </div>
            <div class="gap" *ngIf="loginPersonType == 'Business Admin' || loginPersonType == 'Provider Manager'"></div>
            <div class="add-button-container" [hidden]="paramFieldForce == 'People' && loginUserBusinessCategory == 'Provider' && businessEntities.length == 0 && loginPersonType == 'Business Admin' || loginPersonType == 'Provider Manager'" (click)="openForm()">
              <button class="button">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
                <span class="text">Add New</span>
              </button>
            </div>
          </div>
          <!--Persons of Farm business which are under Provider Business (BUsiness admin login)-->
          <div class="cards_container" *ngIf="paramFieldForce == 'People' && (disptotalBaBusinessPersons?.length > 0 && loginUserBusinessCategory == 'Provider')">
            <div class="card_wrapper" *ngFor="let eachaactivedocdata of baBusinessPersons; let i = index">
              <div class="each_card_div">
                <div class="card_content">
                  <div class="card_header">
                    <div class="img_cum_business_name_div">
                      <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                      <span>{{ eachaactivedocdata.firstName + ' ' + eachaactivedocdata.lastName }}</span>
                    </div>
                    <span class="business_type_heading">{{ (eachaactivedocdata && eachaactivedocdata.isActive) == true ? 'Active' : 'inActive' }}</span>
                  </div>
                  <div class="card_body">
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/business-name-card-icon.svg">
                      <span>{{ (eachaactivedocdata && eachaactivedocdata.businessID && eachaactivedocdata.businessID.businessName) == null ? 'NA' : (eachaactivedocdata && eachaactivedocdata.businessID && eachaactivedocdata.businessID.businessName) }}</span>
                    </div>
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/phone-card-icon.svg">
                      <span>{{ eachaactivedocdata.dialingCode }} {{ (eachaactivedocdata && eachaactivedocdata.mobileNumber == '' || eachaactivedocdata && eachaactivedocdata.mobileNumber == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.mobileNumber }}</span>
                    </div>
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/email-card-icon.svg">
                      <span>{{ (eachaactivedocdata && eachaactivedocdata.email == '' || eachaactivedocdata && eachaactivedocdata.email == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.email }}</span>
                    </div>
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/address-card-icon.svg">
                      <span class="description">{{
                          (eachaactivedocdata && eachaactivedocdata.address.length > 0 ? (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? ((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) + ', ' + (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) : (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && !(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) : (!(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district) : '')) : 'NA') || 'NA'
                        }}</span>
                    </div>
                  </div>
                </div>
                <div class="card_footer">
                  <div class="separate_field">
                    <span class="field_text">Role:</span>
                    <span class="field_value_text">{{ eachaactivedocdata && eachaactivedocdata.personType[0] && eachaactivedocdata.personType[0].name }}</span>
                  </div>
                  <div class="activities_icons" *ngIf="loginPersonType != 'Provider Manager'">
                    <a><img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Person" class="activities_images edit-icon" (click)="setPersonDetailsInOnLoad(eachaactivedocdata.id)"> </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="paramFieldForce == 'People' && disptotalBaBusinessPersons?.length == 0 && loginUserBusinessCategory == 'Provider'" class="noDataFoundMessage">Farm Persons are not available
          </div>

          <!--Provider Business Persons by level wise-->
          <div *ngIf="paramFieldForce == 'Staff' && businessAdminPersons && businessAdminPersons.length > 0">
            <div class="row levelsBlock">
              <div class="col-xs-12 col-md-11"></div>
              <div class="col-md-12">
                <ol class="tree-structure" [ngClass]="{'tree-structure-login': loginPersonType != 'Business Admin'}">
                  <li *ngFor="let businessPerson of businessAdminPersons; let i = index">
                    <span class="num" *ngIf="loginPersonType == 'Business Admin' && businessPerson.level.length">Level {{ i + 1 }}</span>
                    <ol [ngClass]="{'levelsTrackOnLogin': loginPersonType != 'Business Admin'}" class="levelsTrack">
                      <div class="row row-flex">
                        <div class="col-md-4 col-sm-6 col-xs-12 levelCards" *ngFor="let person of businessPerson.level; let j = index">
                          <div class="content colour-1 hierarchyContent">
                            <div class="col-xs-12">
                              <div class="col-xs-3" (click)="getPersonProfileById(person.id, person.personType[0].name)">
                                                                <span><img
                                                                  src="../../../../../../assets/image/business/customerIcon.svg"
                                                                  height="50" width="50"/></span>
                              </div>
                              <div class="col-xs-7" (click)="getPersonProfileById(person.id, person.personType[0].name)">
                                <p>{{ person.firstName }} {{ person.lastName }}</p>
                                <p>{{ person.employeeDesignation || '- -' }} </p>
                                <p>{{ person.dialingCode }} {{ person.mobileNumber }} </p>
                                <p>{{ person.email || '- -' }} </p>
                              </div>
                              <div class="col-xs-2" style="padding: 0" *ngIf="loginPersonType == 'Business Admin'">
                                &nbsp;&nbsp;&nbsp;
                                <a (click)="setProviderPersonsDetailsOnLoad(person.id)">
                                  <img title="Edit Person" class="activities_images edit-icon" src="assets/images/New_Icons/edit.svg" class="edit_icon">
                                </a>
                              </div>
                            </div>
                            <p *ngIf="person.reportingTo && (person.personType[0].name != 'Business Admin') && loginPersonType == 'Business Admin'">
                              Reporting To: &nbsp;&nbsp;&nbsp;{{ person && person.reportingTo && person.reportingTo.firstName || 'Not Assigned' }} {{ person && person.reportingTo && person.reportingTo.lastName || '' }}</p>
                          </div>
                        </div>
                      </div>
                    </ol>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div *ngIf="paramFieldForce == 'Staff' && businessAdminPersons && businessAdminPersons.length == 0 && loginUserBusinessCategory == 'Provider' && loginPersonType == 'Business Admin'" class="noDataFoundMessage">Managers and Technicians are not available
          </div>

          <div *ngIf="paramFieldForce == 'Staff' && businessAdminPersons && businessAdminPersons.length == 0 && loginUserBusinessCategory == 'Provider' && loginPersonType == 'Provider Manager'" class="noDataFoundMessage">Technicians are not available
          </div>

          <!--All Persons super admin-->
          <div class="cards_container" *ngIf="this.persons?.length > 0">
            <div class="card_wrapper searchfun" *ngFor="let eachaactivedocdata of persons; let i = index">
              <div class="each_card_div">
                <div class="card_content">
                  <div class="card_header">
                    <div class="img_cum_business_name_div">
                      <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                      <span>{{ eachaactivedocdata.firstName + ' ' + eachaactivedocdata.lastName }}</span>
                    </div>
                    <span class="business_type_heading">{{ (eachaactivedocdata && eachaactivedocdata.isActive) == true ? 'Active' : 'inActive' }}</span>
                  </div>
                  <div class="card_body">
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/business-name-card-icon.svg">
                      <span>{{ (eachaactivedocdata && eachaactivedocdata.businessID && eachaactivedocdata.businessID.businessName) == null ? 'NA' : (eachaactivedocdata && eachaactivedocdata.businessID && eachaactivedocdata.businessID.businessName) }}</span>
                    </div>
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/phone-card-icon.svg">
                      <span>{{ eachaactivedocdata.dialingCode }} {{ (eachaactivedocdata && eachaactivedocdata.mobileNumber == '' || eachaactivedocdata && eachaactivedocdata.mobileNumber == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.mobileNumber }}</span>
                    </div>
                    <div>
                      <img src="../../../../../../assets/images/New_Icons/email-card-icon.svg">
                      <span>{{ (eachaactivedocdata && eachaactivedocdata.email == '' || eachaactivedocdata && eachaactivedocdata.email == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.email }}</span>
                    </div>
                    <div>
                      <img src="../../../../../../../assets/images/New_Icons/address-card-icon.svg">
                      <span class="description">{{
                          (eachaactivedocdata && eachaactivedocdata.address.length > 0 ? (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? ((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) + ', ' + (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) : (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && !(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) : (!(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district) : '')) : 'NA') || 'NA'
                        }}</span>
                    </div>
                  </div>
                </div>
                <div class="card_footer">
                  <div class="separate_field">
                    <span class="field_text">Role:</span>
                    <span class="field_value_text">{{ eachaactivedocdata && eachaactivedocdata.personType[0] && eachaactivedocdata.personType[0].name }}</span>
                  </div>
                  <div class="activities_icons">
                    <a><img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Person" class="activities_images edit-icon" (click)="setPersonDetailsInOnLoad(eachaactivedocdata.id)"></a>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="NoDataMessage" class="noDataFoundMessage">No Data Available</div>
          </div>

          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
        </div>
        <!--add person modal popup-->
        <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
          <div class="popup-wrapper">
            <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">&times;</button>
            <!-- Actual Popup -->
            <div [ngClass]="{ 'form-container-panel': formFieldCount > 7,'popup-inner': formFieldCount <= 7}">
              <form [formGroup]="addPerson" novalidate>
                <!-- Title -->
                <div class="form-header">
                  <div class="form-title">Person</div>
                  <button class="add-update-submit-button" (click)="submitButton ? personDetailsSubmit() : personUpdateDetailsSubmit()" [disabled]="personCreationDoubleClick">
                    <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
                    <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                  </button>
                </div>
                <div class="form-container grid-three-cols" (clickOutside)="
                  businessesListDropdownOpen = false;
                  countriesListDropdownOpen  = false
                ">
                  <!-- ───────────── BUSINESS NAME (EMPLOYEE) ───────────── -->
                  <mat-form-field *ngIf="paramFieldForce == 'People'" appearance="outline" class="w-100" [ngClass]="{ disbledCls: updateButton }">
                    <mat-label>Business Name</mat-label>
                    <input matInput id="businessname" autocomplete="off" formControlName="businessType" (keyup)="filterBusinesses($event)" (focus)="filteredBusinessesList = businessEntities" [matAutocomplete]="autoBiz" />

                    <mat-autocomplete #autoBiz="matAutocomplete" (optionSelected)="businessSelected($event.option.value)">
                      <mat-option *ngFor="let option of filteredBusinessesList" [value]="option">
                        {{ option.businessName }}
                      </mat-option>
                    </mat-autocomplete>

                    <mat-hint *ngIf="f.businessType.invalid"><i>Select Business</i></mat-hint>
                    <mat-hint *ngIf="f.businessType.valid"><i>Business selected</i></mat-hint>

                    <mat-error *ngIf="
                      (submitted || f.businessType.touched || f.businessType.dirty) &&
                      f.businessType.hasError('required')
                    ">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── Person Role (Material) ───────── -->
                  <mat-form-field appearance="outline" class="w-100" *ngIf="
                        (BAPersonsAvailable?.length > 0 ||
                        (loginPersonType == 'EMPLOYEE' && businessPersonsCount != 0)) &&
                        businessItem
                    " [ngClass]="personRoleDisabled || (this.paramFieldForce == 'People' && ['Farmer', 'SME', 'Dealer'].includes(this.persontype) && updateButton && loginPersonType != 'EMPLOYEE') ? 'disbledCls' : ''">
                    <mat-label>Role</mat-label>

                    <mat-select name="persontype" id="persontype" [(ngModel)]="persontype" formControlName="person" required (selectionChange)="personRoleOnSelect(persontype); person.reportingTo = undefined; person.farmSiteId = undefined" [ngClass]="{ 'is-invalid': submitted && f.person.errors }">
                      <mat-option value="undefined" disabled selected>select Role</mat-option>
                      <mat-option *ngFor="let role of personRoles" [value]="role.name">
                        {{ role.name }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="submitted && f.person.errors">
                      <i *ngIf="f.person.errors.required">Required.</i>
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────────── FARM SITE SELECTION ───────────── -->
                  <mat-form-field *ngIf="
                    farmSites?.length > 0 &&
                    !['SME', 'Buyer', 'Farm Buddy', 'Business Admin', 'Farmer', 'Farm Manager', 'Dealer'].includes(persontype)
                  " appearance="outline" class="w-100">
                    <mat-label>Farm Sites</mat-label>

                    <mat-select [(ngModel)]="person.farmSiteId" name="formsiteId" formControlName="formsiteId" (selectionChange)="getPondsDetails()">
                      <mat-option value="" disabled>Select Farm Site</mat-option>
                      <mat-option *ngFor="let site of farmSites" [value]="site.id">
                        {{ site.farmNameAtLocation }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="
                      (submitted || f.formsiteId.touched || f.formsiteId.dirty) &&
                      f.formsiteId.errors?.required
                    ">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── Farm Sites – Multi Select (Farm Manager) ───────── -->
                  <mat-form-field *ngIf="
                    farmSites?.length > 0 &&
                    persontype === 'Farm Manager'
                  " appearance="outline" class="w-100">
                    <mat-label>Farm Sites</mat-label>

                    <mat-select [(ngModel)]="siteselectedItems" formControlName="formsiteId" [multiple]="true" [compareWith]="compareSites">
                      <mat-option *ngFor="let site of sitedropdownList" [value]="site" (onSelectionChange)="onSiteToggle(site, $event)">
                        {{ site.itemName }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="
                      (submitted || f.formsiteId.touched || f.formsiteId.dirty) &&
                      f.formsiteId.errors?.required
                    ">
                      Required.
                    </mat-error>
                  </mat-form-field>


                  <!-- ───────────── PONDS (for Farm Investor) ───────────── -->
                  <mat-form-field *ngIf="person.farmSiteId && persontype === 'Farm Investor' && ponds_dropdownList?.length > 0" appearance="outline" class="w-100">
                    <mat-label>Select Ponds</mat-label>

                    <mat-select multiple formControlName="pondId" [(ngModel)]="ponds_selectedItems" [compareWith]="compareItems">
                      <mat-option *ngFor="let pond of ponds_dropdownList" [value]="pond" (onSelectionChange)="onPondToggle(pond, $event)">
                        {{ pond.itemName }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="(submitted || f.pondId.touched || f.pondId.dirty) && f.pondId.errors?.required">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────────── SECTIONS (for all other allowed types) ───────────── -->
                  <mat-form-field *ngIf="
                    person.farmSiteId && persontype == 'Farm Tech' && sections_dropdownList?.length > 0
                  " appearance="outline" class="w-100">
                    <mat-label>Select Sections</mat-label>

                    <mat-select multiple formControlName="sections" [(ngModel)]="sections_selectedItems" [compareWith]="compareSections">
                      <mat-option *ngFor="let sec of sections_dropdownList" [value]="sec" (onSelectionChange)="onSectionToggle(sec, $event)">
                        {{ sec.itemName }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="
                      (submitted || f.sections.touched || f.sections.dirty) &&
                      f.sections.errors?.required
                    ">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── First Name ───────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>First Name</mat-label>
                    <input matInput name="personfname" type="text" placeholder=" " autocomplete="off" formControlName="personFirstName" [(ngModel)]="person.firstName" />
                    <mat-error *ngIf="(submitted || f.personFirstName.touched || f.personFirstName.dirty) && f.personFirstName.errors">
                      <ng-container *ngIf="f.personFirstName.errors.required">Required.</ng-container>
                      <ng-container *ngIf="f.personFirstName.errors.minlength">Minimum 3 characters required.
                      </ng-container>
                      <ng-container *ngIf="f.personFirstName.errors.maxlength">Maximum 30 characters allowed.
                      </ng-container>
                      <ng-container *ngIf="f.personFirstName.errors.pattern">Special characters and numbers not allowed.
                      </ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── Last Name ───────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Last Name</mat-label>
                    <input matInput name="personlname" type="text" placeholder=" " autocomplete="off" formControlName="personLastName" [(ngModel)]="person.lastName" />
                    <mat-error *ngIf="(submitted || f.personLastName.touched || f.personLastName.dirty) && f.personLastName.errors">
                      <ng-container *ngIf="f.personLastName.errors.required">Required.</ng-container>
                      <ng-container *ngIf="f.personLastName.errors.minlength">Minimum 1 character required.
                      </ng-container>
                      <ng-container *ngIf="f.personLastName.errors.maxlength">Maximum 30 characters allowed.
                      </ng-container>
                      <ng-container *ngIf="f.personLastName.errors.pattern">Special characters and numbers not allowed.
                      </ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── Employee Designation ───────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Employee Designation</mat-label>
                    <input matInput name="employeeDesignation" type="text" placeholder=" " autocomplete="off" formControlName="employeeDesignation" [(ngModel)]="person.employeeDesignation" />
                    <mat-error *ngIf="(submitted || f.employeeDesignation.touched || f.employeeDesignation.dirty) && f.employeeDesignation.errors">
                      <ng-container *ngIf="f.employeeDesignation.errors.maxlength">Maximum 30 characters allowed.
                      </ng-container>
                      <ng-container *ngIf="f.employeeDesignation.errors.pattern">Special characters and numbers not allowed.
                      </ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── Employee Code ───────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Employee Code</mat-label>
                    <input matInput name="employeeCode" type="text" placeholder=" " autocomplete="off" formControlName="employeeCode" [(ngModel)]="person.employeeCode" />
                    <mat-error *ngIf="(submitted || f.employeeCode.touched || f.employeeCode.dirty) && f.employeeCode.errors">
                      <ng-container *ngIf="f.employeeCode.errors.minlength">Minimum 3 characters required.
                      </ng-container>
                      <ng-container *ngIf="f.employeeCode.errors.maxlength">Maximum 10 characters allowed.
                      </ng-container>
                      <ng-container *ngIf="f.employeeCode.errors.pattern">Special characters are not allowed.
                      </ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── Email ───────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input matInput name="updateemail" type="text" placeholder=" " autocomplete="off" formControlName="email" [(ngModel)]="person.email" />
                    <mat-error *ngIf="(submitted || f.email.touched || f.email.dirty) && f.email.errors">
                      <ng-container *ngIf="f.email.errors.pattern">Email must be a valid email address.</ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────────── COUNTRY (autocomplete) ───────────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Country Selection</mat-label>
                    <input matInput id="countryname" autocomplete="off" formControlName="countryName" [matAutocomplete]="autoCountry" (focus)="filteredCountriesList=countries;" (keyup)="filterCountries()" />
                    <mat-autocomplete #autoCountry="matAutocomplete" (optionSelected)="countrySelected($event.option.value);">
                      <mat-option *ngFor="let c of filteredCountriesList" [value]="c">
                        {{ c.name }}
                      </mat-option>
                    </mat-autocomplete>

                    <mat-hint *ngIf="f.countryName.invalid"><i>Select country</i></mat-hint>
                    <mat-hint *ngIf="f.countryName.valid"><i>Country selected</i></mat-hint>

                    <mat-error *ngIf="(submitted || f.countryName.touched || f.countryName.dirty) && f.countryName.hasError('required')">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────────── DIAL CODE (readonly) ───────────── -->
                  <mat-form-field appearance="outline" class="w-100 dialcode-farm-element">
                    <mat-label>Dial Code</mat-label>
                    <input matInput id="dialCode" readonly formControlName="dialCode" [(ngModel)]="person.dialingCode" />
                    <mat-error *ngIf="(submitted || f.dialCode.touched || f.dialCode.dirty) && f.dialCode.hasError('required')">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── STATE ───────── -->
                  <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                    <mat-label>State Selection</mat-label>
                    <input matInput id="state" autocomplete="off" formControlName="stateName" [matAutocomplete]="autoState" [disabled]="stateVillageDisabled" (focus)="filteredStatesList=states" (keyup)="filterStates($event)" />

                    <mat-autocomplete #autoState="matAutocomplete" (optionSelected)="stateSelection($event.option.value)">
                      <mat-option *ngFor="let s of filteredStatesList" [value]="s">
                        {{ s.name }}
                      </mat-option>
                    </mat-autocomplete>

                    <mat-hint *ngIf="f.stateName.invalid">
                      <i>Select state</i>
                    </mat-hint>
                    <mat-hint *ngIf="f.stateName.valid">
                      <i>State selected</i>
                    </mat-hint>

                    <mat-error *ngIf="(submitted || f.stateName.touched || f.stateName.dirty) && f.stateName.hasError('required')">
                      Required.
                    </mat-error>
                  </mat-form-field>

                  <!-- ───────── VILLAGE ───────── -->
                <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                  <mat-label>Village Selection</mat-label>

                  <input
                    matInput
                    id="village"
                    autocomplete="off"
                    formControlName="villageName"
                    [matAutocomplete]="autoVillage"
                    [disabled]="stateVillageDisabled || isLoadingVillages"
                    (keyup)="filterVillages($event)"
                    (focus)="onVillageFocus()"
                    (blur)="onVillageBlur()"
                    #autoTrigger="matAutocompleteTrigger"
                  />

                  <!-- Loader while fetching API -->
                  <mat-spinner *ngIf="isLoadingVillages" diameter="20" class="absolute right-2 top-2"></mat-spinner>

                  <mat-autocomplete #autoVillage="matAutocomplete" panelClass="village-panel">
                    <!-- Error message if API fails -->
                    <mat-option *ngIf="villagesLoadError" disabled>
                      Villages fetching failed. Reselect state to retry.
                    </mat-option>

                    <!-- No data found message -->
                    <mat-option *ngIf="noDataFound" disabled>
                      No data found
                    </mat-option>

                    <!-- Virtual Scroll Container -->
                    <cdk-virtual-scroll-viewport itemSize="48" style="height: 250px;" 
                      [style.height.px]="visibleVillages.length < CHUNK_SIZE ? visibleVillages.length * 48 : 250"
                      (scrolledIndexChange)="onVillageScroll()"
                      [minBufferPx]="500"
                      [maxBufferPx]="1000">
                      <div *cdkVirtualFor="let v of visibleVillages; let i = index">
                        <mat-option [value]="v.city_town_village_name" (click)="villageSelection(v)">
                          {{ v.city_town_village_name }}
                        </mat-option>
                      </div>

                      <!-- Loader inside scroll -->
                      <div class="loader-section" *ngIf="isLoadingMore">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Loading more...</span>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </mat-autocomplete>

                  <mat-hint *ngIf="f.villageName.invalid"><i>Select village</i></mat-hint>
                  <mat-hint *ngIf="f.villageName.valid"><i>Village selected</i></mat-hint>

                  <mat-error *ngIf="(submitted || f.villageName.touched || f.villageName.dirty) && f.villageName.hasError('required')">
                    Required.
                  </mat-error>
              </mat-form-field>

                  <!-- ───────────── MOBILE NUMBER ───────────── -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Mobile Number</mat-label>
                    <input matInput id="phonenumber" autocomplete="off" formControlName="personMobileNumber" [(ngModel)]="person.mobileNumber" />

                    <mat-error *ngIf="(submitted || f.personMobileNumber.touched || f.personMobileNumber.dirty) && f.personMobileNumber.errors">
                      <ng-container *ngIf="f.personMobileNumber.hasError('required')">Required.</ng-container>
                      <ng-container *ngIf="f.personMobileNumber.hasError('pattern')">Invalid mobile number.
                      </ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- Pincode Entry Field -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Pincode</mat-label>
                    <input matInput type="text" name="pincode" placeholder=" " autocomplete="off" formControlName="pincode" [(ngModel)]="person.pincode" />
                    <mat-error *ngIf="(submitted || f.pincode.touched || f.pincode.dirty) && f.pincode.errors">
                      <ng-container *ngIf="f.pincode.errors.required">Required.</ng-container>
                      <ng-container *ngIf="f.pincode.errors.pattern">Invalid pincode.</ng-container>
                    </mat-error>
                  </mat-form-field>

                  <!-- Reporting To Selection Field -->
                  <mat-form-field
                    appearance="outline"
                    class="w-100"
                    *ngIf="!(persontype === 'Business Admin' || 
                            (['Farmer', 'SME', 'Dealer'].includes(persontype) && paramFieldForce === 'People' && loginPersonType != 'EMPLOYEE')) && persontype && businessItem?.businessType?.[0]?.name != 'External'"
                    [ngClass]="personRoleDisabled ? 'disbledCls' : ''"
                  >
                    <mat-label>Reporting To</mat-label>
                    <mat-select
                      name="reportingto"
                      formControlName="level"
                      [(ngModel)]="person.reportingTo"
                      (selectionChange)="person.level = 1"
                    >
                      <mat-option value="undefined" disabled selected>Select Reporting To</mat-option>
                      <mat-option *ngFor="let report of personsByBusiness" [value]="report.id">
                        {{ report.firstName + ' ' + report.lastName }}
                      </mat-option>
                    </mat-select>

                    <mat-error *ngIf="(submitted || f.level.touched || f.level.dirty) && f.level.errors">
                      <ng-container *ngIf="f.level.errors.required">Required.</ng-container>
                    </mat-error>
                  </mat-form-field>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!--person Profile-->
        <div class="modal fade" id="personProfileModal" role="dialog">
          <div class="modal-dialog modal-lg addBusinessEntityModal">
            <div class="modal-content eachContent">
              <div class="modal-header">
                <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;
                </button>
                <h4 class="modal-title">User Profile</h4>
              </div>
              <!--<div [hidden]="responseLoader">
<div class="adjust loader-container">
<div class="loader2"></div>
</div>
</div>-->
              <div class="modal-body eachCustomer">
                <div [hidden]="responseLoader">
                  <div class="adjust loader-container">
                    <div class="loader2"></div>
                  </div>
                </div>
                <div class="row" [hidden]="!responseLoader">
                  <div class="col-xs-5">
                    <div class="row person-row-flex">
                      <div class="col-md-12 col-sm-6 col-xs-12">
                        <div class="personcontent personcolour-1">
                          <div class="row">
                            <div class="col-xs-8">
                              <h4>{{ personProfile && personProfile.firstName }} {{ personProfile && personProfile.lastName }}
                                <span>{{ personProfile && personProfile.employeeCode }}</span></h4>
                              <p>{{ personProfile && personProfile.employeeDesignation || '- -' }}</p>
                              <p>{{ personProfile && personProfile.mobileNumber }}</p>
                            </div>
                            <div class="col-xs-4">
                              <img src="../../../../../../assets/image/business/customerIcon.svg" />
                            </div>
                          </div>
                          <hr>
                          <p>Reporting To</p>
                          <h4 *ngIf="loginPersonType == 'Business Admin'">{{ personProfile && personProfile.reportingTo && personProfile.reportingTo.firstName || 'Not Assigned' }} {{ personProfile && personProfile.reportingTo && personProfile.reportingTo.lastName }}</h4>
                          <h4 *ngIf="loginPersonType == 'Provider Manager'">{{ loginPersonName }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-7" *ngIf="personProfile && personProfile.personType.length > 0 && personProfile.personType[0] && personProfile.personType[0].name == 'Provider Technician'">
                    <div class="row row-flex">
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="profilecontent profilecolour-1">
                          <h4>Total Booked Orders</h4>
                          <h2>{{ personProfile && personProfile.orders || 0 }}</h2>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="profilecontent profilecolour-1">
                          <h4>Farm visit(last month)</h4>
                          <h2>{{ personProfile && personProfile.farmvisits || 0 }}</h2>
                        </div>
                      </div>
                    </div>
                    <div class="row row-flex">
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="profilecontent profilecolour-1">
                          <h4>Total customers</h4>
                          <h2>{{ personProfile && personProfile.businessess || 0 }}</h2>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="profilecontent profilecolour-1">
                          <h4>Travelled last month (Km)</h4>
                          <h2>{{ personProfile && personProfile.totalDistance || 0 }}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Business Admin Person Creation Notification Alert modal popup-->
        <div class="modal fade" id="notification" role="dialog">
          <div class="modal-dialog modal-lg notificationdiv">
            <div class="modal-content notification-modal" style="border-width: none;">
              <div class="modal-body" style="position:relative;height: 97px;">
                <div>
                                    <span><img
                                      src="../../../../../../assets/img/png-icons-blubay/notification_red_alert.svg"
                                      width="20px"
                                      height="20px" style="margin: 0 16px 0 7px;"></span>
                  <span class="notificationtext">Your account / site administrator is not registered with us</span>
                </div>
                <div style="text-align: right;margin-top: 15px;" *ngIf="loginPersonType == 'Farmer'">
                  <button class="modal-btn registerbtn" (click)="BAPersonRegistration()">Register</button>
                  <button class="modal-btn skipbtn" (click)="skipRegistration()">Skip</button>
                </div>
                <div style="text-align: right;margin-top: 15px;" *ngIf="loginPersonType == 'Farm Manager'">
                  <button class="modal-btn registerbtn" (click)="skipRegistration()">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Business Admin Person Creation Notification Alert modal popup-->
      </div>
    </div>
  </div>
</div>
